exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".banner[data-v-8715d93c]{height:540px}.banner .left[data-v-8715d93c]{width:600px;padding-top:199px;text-align:left}.banner .left h1[data-v-8715d93c]{font-size:40px;line-height:40px;padding-bottom:34px}.banner .left strong[data-v-8715d93c]{font-size:24px;color:#6d6d6d;line-height:46px;white-space:pre}", ""]);

